import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { Grid } from '@mui/material';
import { ScreenshotAssetView } from './ScreenshotAssetView';
import ScreenshotAssetViewByDate from './ScreenshotAssetViewByDate';

const PREFIX = 'ScreenShotDialog';

const classes = {
    appBar: `${PREFIX}-appBar`,
    title: `${PREFIX}-title`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.appBar}`]: {
		position: 'relative',
	},

    [`& .${classes.title}`]: {
		marginLeft: theme.spacing(2),
		flex: 1,
	}
}));

interface ScreenShotDialogProps {
	showScreenShotModal: boolean;
	handleCloseModal: any;
	advertisementId: number;
	campaignId: number;
	clientId: number;
}
export default function ScreenShotDialog(props: ScreenShotDialogProps) {
	const { showScreenShotModal, handleCloseModal, advertisementId, campaignId } = props;

	const [title, setTitle] = useState('');

	const handleClose = () => {
		handleCloseModal();
	};

	const handleResult = (result: any) => {
		const updatedTitle = result.campaignName + ' ' + result.advertisementName;
		setTitle(updatedTitle);
	};

	return (
        <Root>
			<Dialog fullScreen open={showScreenShotModal} onClose={handleClose}>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                            size="large">
							<CloseIcon />
						</IconButton>
						<Typography variant="h6" className={classes.title}>
							{title}
						</Typography>
					</Toolbar>
				</AppBar>
				<Grid>
					<ScreenshotAssetViewByDate
						advertisementId={advertisementId}
						campaignId={campaignId}
						handleResult={handleResult}
					/>
				</Grid>
			</Dialog>
		</Root>
    );
}
